(function () {
  class jackpotBonusFeature extends PIXI.Container {
    constructor() {
      super();

      this._reels = [];
      this._stormLinkReels = [];
      this._freeSpinsReels = [];
      this._reelPrizeObjects = [];
      this._inFS = false;
      this._currentSpinPositions = [];
      this._currentBaseGameSymbols = [];
      this._prizes = [];
      this._active = false;
      this._hasLoaded = false;

      this._jackpotBonusIntro = undefined;
      this._jackpotBonusStartData = undefined;
      this._jackpotBonusStartTask = undefined;
      this._endEvent = undefined;

      this._skipped = false;

      this._reelsTimer = undefined;

      this._particleEmitter = undefined;

      this._endTaskWinnings = 0;

      this._maxWinBreached = false;

      this._megaPotValue = 0;
      this._megaPotWon = false;

      this.pots = [];
      this.afterEventsProcessedCallback = undefined;
      this.winningsCounter = undefined;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "8bofBB:JackpotBonusStartEvent",
        this.onjackpotBonusStartEvent.bind(this)
      );
      messageBus.subscribe(
        "8bofBB:JackpotBonusDataEvent",
        this.onjackpotBonusDataEvent.bind(this)
      );
      messageBus.subscribe(
        "8bofBB:JackpotBonusDataEventDead",
        this.onjackpotBonusDataEventDead.bind(this)
      );
      messageBus.subscribe(
        "8bofBB:JackpotBonusEndEvent",
        this.onjackpotBonusEndEvent.bind(this)
      );
      messageBus.subscribe("spinner:SpinEvent", this.onSpin.bind(this));
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onOrientationChange.bind(this)
      );
    }

    onOrientationChange() {
      if (this._active && this._hasLoaded) {
        if (this._logo) {
          this._logo.visible = false;
        }

        if (this.miniPotTrailContainer) {
          this.megaPotTrailContainer.visible = true;
          this.ultraPotTrailContainer.visible = true;
          this.majorPotTrailContainer.visible = true;
          this.minorPotTrailContainer.visible = true;
          this.miniPotTrailContainer.visible = true;
        }
      }
    }

    onStakeChanged(stake) {
      if (stake === undefined) {
        return;
      }

      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      if (
        goldenBetButton !== undefined &&
        goldenBetButton._flags.showGoldenBetActive
      ) {
        goldenBetButton.glow.visible = false;
        stake = stake / gameData.goldenBetMultiplier;
      }
      this._megaPotValue = stake * 5000;
      this._maxWin = stake * 10000;
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      const self = this;

      this._slotMachine = resourceManager.getController("SlotMachine0_1");
      this.reelsBackingContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:reelsBackingContainer"
      );
      this.reelsContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:reelsContainer"
      );
      for (let reel = 0; reel < 3; ++reel) {
        this._reelPrizeObjects.push([]);
        const rv = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:jackpotBonusFeature:reel" +
            reel
        );
        this._reels.push(rv);

        rv.reassignSlotMachine(this._slotMachine);
        const prizeContainer = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel
        );
        prizeContainer.visible = false;

        const value = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":value"
        );
        value.visible = false;

        const mini = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":mini"
        );
        mini.visible = false;

        const mini_double = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":mini_double"
        );
        mini_double.visible = false;

        const minor = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":minor"
        );
        minor.visible = false;

        const minor_double = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":minor_double"
        );
        minor_double.visible = false;

        const major = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":major"
        );
        major.visible = false;

        const major_double = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":major_double"
        );
        major_double.visible = false;

        const mega = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":mega"
        );
        mega.visible = false;

        const mega_double = resourceManager.get(
          "slotContainer:firelinkPrizes:firelinkPrize" + reel + ":mega_double"
        );
        mega_double.visible = false;

        this._reelPrizeObjects[reel].push({
          container: prizeContainer,
          text: value,
          mini,
          minor,
          major,
          mega,
          mini_double,
          minor_double,
          major_double,
          mega_double,
        });
      }

      this._particleSparkEmitter = particleManager.createEmitter(
        "sparks_emitter",
        "slotContainer:firelinkPrizes:particleContainer",
        0,
        0,
        false
      );

      this._particleSparkEmitter.particleEmitter.emit = false;

      this._particleEmitter = particleManager.createEmitter(
        "coin_emitter",
        "slotContainer:firelinkPrizes:particleContainer",
        0,
        0,
        false
      );
      this._particleEmitter.particleEmitter.emit = false;

      const coinContainer = resourceManager.get(
        "slotContainer:firelinkPrizes:coinContainer"
      );
      this._coinGroup1 = [];
      this._coinGroup2 = [];
      this._coinGroups = [this._coinGroup1, this._coinGroup2];
      this._currentCoinGroup = 0;

      for (let i = 0; i < 8; i++) {
        const coin = new PIXI.Sprite.fromImage(
          ReflexLoader.rootResDir + "Particles/Coin/Coin_00001.png"
        );
        coinContainer.addChild(coin);
        coin.visible = false;

        if (i < 4) {
          this._coinGroup1.push(coin);
        } else {
          this._coinGroup2.push(coin);
        }
      }

      this._slotMachine.selectReelMode("default");

      this._slotMachine.subscribeToReelsHitEvent(function (reelId) {
        self.onSpinHit(reelId);
      });

      this._winningsPanel = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:moneyPanel"
      );
      this._winningsPanel.visible = false;
      this._winningsText = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:moneyPanel:winnings"
      );

      this.winningsCounter = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:winningsCounter"
      );
      this.winningsCounter.visible = false;
      this.winningsCounterText = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:winningsCounter:winnings"
      );

      this._fireBallIntro = resourceManager.get(
        "slotContainer:jackpotIntroPopup:jackpotIntro"
      );

      this._linkBG = resourceManager.get(
        "baseGameBackground:landscapeBackground:nightBackground"
      );
      this._linkBG.visible = false;

      this._linkBGPortrait = resourceManager.get(
        "baseGameBackground:portraitBackground:nightBackground"
      );

      this._linkBGPortrait.visible = false;

      this._volcanoPot = resourceManager.get("potContainer");

      this._shaker = resourceManager.get("reelsShaker");

      this._fireballLandAnimator = resourceManager.get(
        "slotContainer:FireballLandAnimator"
      );

      this._megaValue = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:megaValue"
      );
      this._megaValue.visible = false;

      this.visible = false;

      this.endingWinSequence = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:EndingWinSequence"
      );

      this.endingWinValue = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:EndingWinSequence:WinValueContrainer:WinValue"
      );

      this.endingWinValueContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:EndingWinSequence:WinValueContrainer"
      );

      this.keepGoing = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:KeepGoingPopup:JBF_KeepGoing"
      );

      this.rays = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:KeepGoingPopup:rays"
      );

      this.dimReels = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:dimReels"
      );

      this.arrowL = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:reelsContainer:arrowL"
      );
      this.arrowR = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:reelsContainer:arrowR"
      );
      this.megaPotTrailContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:MegaPotTrailContainer"
      );
      this.ultraPotTrailContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:UltraPotTrailContainer"
      );
      this.majorPotTrailContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:MajorPotTrailContainer"
      );
      this.minorPotTrailContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:MinorPotTrailContainer"
      );
      this.miniPotTrailContainer = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:MiniPotTrailContainer"
      );

      this.setUpPotTrails();
      this.setupArrowPulse();

      const license = gameController.license.toUpperCase();

      if (license === "DE" || license === "LT" || license === "FIN") {
        resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:reelsContainer:infoPanel:GrandPrizeReels"
        ).visible = true;
        resourceManager.get(
          "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:jpTitle"
        ).visible = false;
        resourceManager.get(
          "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:jpTitle_Alt"
        ).visible = true;
      } else {
        resourceManager.get(
          "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:jpTitle"
        ).visible = true;
        resourceManager.get(
          "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:jpTitle_Alt"
        ).visible = false;
      }

      for (let i = 0; i < this._slotMachine._reelVisuals.length; i++) {
        this._slotMachine._reelVisuals[i].suspendUpdates();
      }
      this._hasLoaded = true;
    }

    onSpinHit(reel) {
      let slotCount = +reel.replace("reel", "");
      let id = undefined;
      if (this.symbolAwards[slotCount].type === "Blank") {
        soundManager.play("reelNull");
      } else if (this.symbolAwards[slotCount].type === "Cash") {
        soundManager.play(`reelJackpot${slotCount}`);
        id = 16;
      } else {
        soundManager.play(`reelJackpot${slotCount}`);
      }
      this._reels[slotCount].bounceOverlays(1, id);
      this._reels[slotCount].bounceSymbol(1);

      // play landing sound - this is quiet against the theme music
      if (slotCount === this._slotMachine.reels.length - 1) {
        soundManager.stop("reelSpin");
      }
      soundManager.play("reelStop" + slotCount);
    }

    onSpin(task) {
      this._currentBaseGameSymbols = [];
      this._isWildFire = task.data.isWildFire;
      for (let reel = 0; reel < task.data.resultPanel.reelList.length; reel++) {
        this._currentBaseGameSymbols.push([]);
        for (
          let row = 0;
          row < task.data.resultPanel.reelList[reel].symbols.length;
          row++
        ) {
          this._currentBaseGameSymbols[reel].push(
            task.data.resultPanel.reelList[reel].symbols[row].value
          );
        }
      }
    }

    getNextSpinOutcome() {
      messageBus.post("spinner:stormLink");

      gdk.getNextGameOutcome(function () {});
    }

    onjackpotBonusStartEvent(task) {
      // set off the intro
      this._active = true;
      this._fireballLinkStartTask = task;
      this._fireballLinkStartTask.join();
      this._lockedReels = [];
      this._newLockedReels = [];
      const self = this;
      this.processingFinalSpin = false;
      self.jackpotAwarded = false;

      let goldenBetButton = resourceManager.get("goldenBetToggleButton");
      goldenBetButton.glow.visible = false;
      resourceManager.get("slotContainer:jackpotReelsLogo").visible = false;
      resourceManager.get("slotContainer:triggeredByVolcano").visible = false;

      gameController.blazingMultiplierContainer.visible = false;

      for (let i = 0; i < this._slotMachine._reelVisuals.length; i++) {
        this._slotMachine._reelVisuals[i].clearSuspendUpdates();
      }
      for (let i = 0; i < gameController.slotMachine._reelVisuals.length; i++) {
        gameController.slotMachine._reelVisuals[i].suspendUpdates();
      }

      for (let reelIndex = 0; reelIndex < 3; ++reelIndex) {
        this._reelPrizeObjects.push([]);
        const reel = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:jackpotBonusFeature:reel" +
            reelIndex
        );
        for (let row = 0; row < 3; row++) {
          const symbol = task.data.stopWindow.reelList[reelIndex].symbols[row];
          reel.setReelSymbol(row, symbol);
        }

        for (let row = 3; row < 7; row++) {
          const symbol = 18;
          reel.setReelSymbol(row, symbol);
        }
      }

      for (let index = 0; index < this.pots.length; index++) {
        const pot = this.pots[index];
        pot.value.setText(pot.reelValue.text);
      }

      this._winnings = 0;

      self.winningsCounterText.setText(
        PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
          0
        )
      );

      gameController.stormLinkSkip = true;

      this._jackpotBonusStartData = task.data;

      this._linkBG.visible = true;
      this._linkBGPortrait.visible = true;
      gameController.isInFeature = true;

      this._volcanoPot.visible = false;

      gameController.wildLandAnimator.skip();

      timerManager.addTimeout(100, function () {
        self._shaker.doShake(1500);

        timerManager.addTimer(
          1200,
          function (progress) {},
          function () {
            gameController.volcanoExplosion.visible = true;
            gameController.volcanoParticle.particleEmitter.emit = false;

            gameController.volcanoExplosion.gotoAndStop(0);
            gameController.volcanoExplosion.play();
            gameController.volcanoExplosion.onComplete = () => {
              gameController.volcanoExplosion.visible = false;
            };
            //play explosion
          }
        );
        gameData.musicManager.fadeOutAllMusic();
        gameData.musicManager.fadeInJackPotMusic();
        gameController.volcano.play(
          "Volcano_Blow",
          false,
          0,
          self.fireFireballAtScreen.bind(self)
        );
      });
      this.symbolAwardIndex = 0;

      //this._fireBallIntro.showIntro(this.jackpotBonusStartCallback.bind(this));
    }

    fireFireballAtScreen() {
      const self = this;

      gameController.updateVolcanoLevel(
        gameController.currentPersistenceState.playerState.volcanoLevel,
        true
      );

      const introFireball = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:PotFireballSprites:IntroFireball"
      );
      introFireball.visible = true;

      introFireball.position.y = resourceManager.get(
        "slotContainer:jackpotBonusFeatureContainer:PotFireballSprites:FireballStartPos"
      ).position.y;

      let endYPos = resourceManager.get(
        "slotContainer:jackpotIntroPopup:jackpotIntro:GoldBackground:clickContinue"
      ).y;

      const duration = 1;
      introFireball.scale = { x: 0, y: 0 };
      gsap.to(introFireball, {
        duration: duration,
        ease: "linear",
        x: 700,
        y: endYPos,
        onComplete: () => {
          gameController.inFirelink = true;
          resourceManager.getController("inputOverlord").setState("freespins");

          gameController.wildLandAnimator.visible = false;

          introFireball.visible = false;

          gameController.baseReelFrame.visible = false;

          for (let index = 0; index < this.pots.length; index++) {
            const pot = this.pots[index];
            pot.mainContainer.visible = true;
            for (let tIndex = 0; tIndex < pot.trails.length; tIndex++) {
              const trail = pot.trails[tIndex];
              trail.activeFireball.visible = false;
            }
          }

          self.reelsBackingContainer.visible = true;
          self.reelsContainer.visible = true;

          gameController.slotMachine.clearDimSymbolIds();

          self._logo = resourceManager.get("baseGameLogo");
          self._logo.visible = false;

          self._winningsText.setText("0.00");
          self._winnings = 0;
          self.winningsCounter.visible = true;
          self.winningsCounterText.visible = true;

          resourceManager.get("slotContainer:reelContainer").visible = false;
          self.visible = true;

          this._fireBallIntro.showIntro(
            this.jackpotBonusStartCallback.bind(self)
          );
        },
      });
      gsap.to(introFireball.scale, {
        duration: duration,
        ease: "linear",
        x: 6,
        y: 6,
        onComplete: () => {
          // Now show the intro screen
        },
      });
    }

    jackpotBonusStartCallback() {
      messageBus.post("spinner:stormLink");
      this._fireballLinkStartTask.leave();

      this._prizes = [];

      const self = this;

      // slightly delay the first spin to give player the chance of seeing
      // initial number of respins otherwise it will have decremented straight away
      timerManager.addTimer(1000, undefined, function () {
        self.getNextSpinOutcome();
      });
    }

    processMultiSymbolWilds(reel, row, newSymbolId) {
      const symbolsInfo = resourceManager.getConfiguration().symbols;
      //if this fireball is going into a slot currently occupied by part of a x2 or 2x wild, we need to change the rest of that 2x or x3 wild
      const baseGameSymbolid = this._currentBaseGameSymbols[reel][row];
      if (baseGameSymbolid === symbolsInfo["Symbol_SWild_x2"].ID) {
        if (row === 0) {
          //if the x2 wild starts on the top row, we need to turn the row below into a x1 wild
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild"].ID;
        } else if (row === 1) {
          //find out if the symbol above or below is the rest of the 2x wild and turn that one into a x1 wild
          if (
            this._currentBaseGameSymbols[reel][row - 1] ===
            symbolsInfo["Symbol_SWild_x2"].ID
          ) {
            gameData.reels[reel].setReelSymbol(
              row - 1,
              symbolsInfo["Symbol_SWild"].ID
            );
            this._currentBaseGameSymbols[reel][row - 1] =
              symbolsInfo["Symbol_SWild"].ID;
          } else {
            gameData.reels[reel].setReelSymbol(
              row + 1,
              symbolsInfo["Symbol_SWild"].ID
            );
            this._currentBaseGameSymbols[reel][row + 1] =
              symbolsInfo["Symbol_SWild"].ID;
          }
        } else {
          //if the x2 wild starts on the top row, we need to turn the row above into a x1 wild
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild"].ID;
        }
      } else if (baseGameSymbolid === symbolsInfo["Symbol_SWild_x3"].ID) {
        if (row === 0) {
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row + 2,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild_x2"].ID;
          this._currentBaseGameSymbols[reel][row + 2] =
            symbolsInfo["Symbol_SWild_x2"].ID;
        } else if (row === 1) {
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row + 1,
            symbolsInfo["Symbol_SWild"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild"].ID;
          this._currentBaseGameSymbols[reel][row + 1] =
            symbolsInfo["Symbol_SWild"].ID;
        } else {
          gameData.reels[reel].setReelSymbol(
            row - 1,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          gameData.reels[reel].setReelSymbol(
            row - 2,
            symbolsInfo["Symbol_SWild_x2"].ID
          );
          this._currentBaseGameSymbols[reel][row - 1] =
            symbolsInfo["Symbol_SWild_x2"].ID;
          this._currentBaseGameSymbols[reel][row - 2] =
            symbolsInfo["Symbol_SWild_x2"].ID;
        }
      }
      this._currentBaseGameSymbols[reel][row] = newSymbolId;
    }

    doSlamStop() {
      if (!this._active) return;

      let reelsToSlam = [];

      for (var i = 0; i < 3; i++) {
        reelsToSlam.push(i);
      }
      this._slotMachine.slamReels(reelsToSlam);

      if (this._reelsTimer !== undefined) {
        this._reelsTimer.remainingTime = 0;
      }
      soundManager.stop("reelSpin");
    }

    onjackpotBonusDataEvent(task) {
      const self = this;
      this._dataEvent = task;
      this._dataEvent.join();

      this.processingFinalSpin = task.data.finalSpin;

      this.symbolAwards = task.data.symbolAwards.symbolAwards;
      this.symbolAwardIndex = 0;
      this.afterEventsProcessedCallback =
        self.onfireballLinkDataEventCallback.bind(self);
      soundManager.play("reelSpin");
      this._slotMachine.infiniteSpin();

      let symbols = [];
      let above = [];
      let below = [];
      for (let reel = 0; reel < task.data.stopWindow.reelList.length; reel++) {
        symbols.push([]);
        above.push([]);
        below.push([]);
        for (
          let row = 0;
          row < task.data.stopWindow.reelList[reel].symbols.length;
          row++
        ) {
          const symbolId =
            task.data.stopWindow.reelList[reel].symbols[row].value;
          symbols[reel].push(symbolId);

          if (this.symbolAwards[reel].type === "Cash") {
            const onReelsFireballText = resourceManager.get(
              `slotContainer:jackpotBonusFeatureContainer:jackpotBonusFeature:reel${reel}:symbol${1}:symbol:childContainer:fireballCashOverlay`
            );
            onReelsFireballText.modifiedValue =
              this.symbolAwards[reel].winAmount;
          } else {
            const onReelsFireballText = resourceManager.get(
              `slotContainer:jackpotBonusFeatureContainer:jackpotBonusFeature:reel${reel}:symbol${1}:symbol:childContainer:fireballCashOverlay`
            );
            onReelsFireballText.modifiedValue = undefined;
          }
        }
      }

      this._slotMachine.stopReels(symbols, above, below, function () {
        self.repeatPulseArrow = true;
        self.lArrowPulse.play();
        self.rArrowPulse.play();
        timerManager.addTimeout(1000, function () {
          self.processSymbolAwards();
          //self._dataEvent.leave();
        });
      });
    }

    processSymbolAwards() {
      //this.afterEventsProcessedCallback  << Set this so after events we know where to go.

      if (this.symbolAwardIndex >= this.symbolAwards.length) {
        //this.symbolAwardIndex = 0;
        this.repeatPulseArrow = false;
        return this.finishProcessingSymbolAwards();
      }
      if (this.symbolAwards.length > 0) {
        const award = this.symbolAwards[this.symbolAwardIndex];
        this.symbolAwardIndex++;
        switch (award.type) {
          case "Jackpot":
            this.processAward_Jackpot(
              award,
              this.processSymbolAwards.bind(this)
            );
            break;
          case "Cash":
            this.processAward_Cash(award, this.processSymbolAwards.bind(this));
            break;
          default:
            this.processSymbolAwards();
            break;
        }
      } else {
        console.log("NO FIREBALL LINK EVENTS!");
        this.finishProcessingSymbolAwards();
      }
    }

    processAward_Jackpot(award, cb) {
      // {
      //               "type": "Jackpot",
      //               "winAmount": 0,
      //               "winCapped": false,
      //               "symbol": "Minor",
      //               "jackpotAwarded": false,
      //               "newTrailPosition": 1,
      //               "newJackpotAmount": -1
      // },
      let potChosen = undefined;
      for (let index = 0; index < this.pots.length; index++) {
        const pot = this.pots[index];
        if (pot.name === award.symbol) {
          potChosen = pot;
        }
      }

      //const pos = this.getSymbolPos(this.symbolAwardIndex - 1, 1);
      const pos = this._slotMachine.getSymbolPosition(
        this.symbolAwardIndex - 1,
        1
      );
      // const offSet = resourceManager.get(
      //   "slotContainer:jackpotBonusFeatureContainer:" +
      //     award.symbol +
      //     "PotTrailContainer"
      // );
      // pos.x -= offSet.x;
      // pos.y -= offSet.y;

      const symbol = potChosen.fireBall;
      symbol.visible = true;
      symbol.position = pos;

      const duration = 0.5;
      // Move the fireball
      soundManager.play(
        `jpWhoosh${Math.floor(Math.random() * (2 - 0 + 1)) + 0}`
      );
      this.moveSymbolXToPotTweenProgress = 0;
      gsap.to(this, {
        moveSymbolXToPotTweenProgress: 100,
        duration: duration,
        ease: "power1.inOut",
        onUpdate: () => {
          const endPosX = this.getEndPos(
            award.symbol,
            award.newTrailPosition - 1
          ).x;
          const posDiffX = endPosX - pos.x;
          symbol.x =
            pos.x + posDiffX * (this.moveSymbolXToPotTweenProgress / 100);
        },
      });
      this.moveSymbolYToPotTweenProgress = 0;
      gsap.to(this, {
        moveSymbolYToPotTweenProgress: 100,
        duration: duration,
        ease: "power1.in",
        onUpdate: () => {
          const endPosY = this.getEndPos(
            award.symbol,
            award.newTrailPosition - 1
          ).y;
          const posDiffY = endPosY - pos.y;
          symbol.y =
            pos.y + posDiffY * (this.moveSymbolYToPotTweenProgress / 100);
        },
        onComplete: () => {
          // call new function that does pulses etc
          symbol.visible = false;
          this.doAfterMovingBall(award, potChosen, cb);
        },
      });

      // Move the trailing particle

      // switch the particle based on the fireball type
      const particle = potChosen.emitter;

      particle.particleEmitter.spawnPos = pos;
      //particle.particleEmitter.cleanup();
      //particle.particleEmitter.spawnPos = { x: 0, y: 0 };
      particle.particleEmitter.spawnPos.y += 70;
      particle.particleEmitter.emitterLifetime = duration * 2;
      particle.particleEmitter.maxLifetime = duration * 5;
      particle.particleEmitter.minLifetime = duration * 2;
      particle.visible = true;
      particle.particleEmitter.playOnce(() => {
        particle.visible = false;
      });

      const initialParticlePositionX = particle.particleEmitter.spawnPos.x;
      const initialParticlePositionY = particle.particleEmitter.spawnPos.y;
      this.particleMoveTweenProgress = 0;
      gsap
        .timeline()
        .to(this, {
          particleMoveTweenProgress: 100,
          duration: duration,
          ease: "power1.inOut",
          onUpdate: () => {
            const endPosX = this.getEndPos(
              award.symbol,
              award.newTrailPosition - 1
            ).x;
            const posDiffX = endPosX - initialParticlePositionX;
            particle.particleEmitter.spawnPos.x =
              initialParticlePositionX +
              posDiffX * (this.particleMoveTweenProgress / 100);
          },
          onComplete: () => {
            this.particleMoveTweenProgress = 0;
          },
        })
        .to(
          this,
          {
            particleMoveTweenProgress: 100,
            duration: duration,
            ease: "power1.in",
            onUpdate: () => {
              const endPosY = this.getEndPos(
                award.symbol,
                award.newTrailPosition - 1
              ).y;
              const posDiffY = endPosY - initialParticlePositionY;
              particle.particleEmitter.spawnPos.y =
                initialParticlePositionY +
                posDiffY * (this.particleMoveTweenProgress / 100);
            },
          },
          "<"
        );
    }

    getEndPos = function (awardType, amount) {
      const thisPos = resourceManager.get(
        `slotContainer:jackpotBonusFeatureContainer:${awardType}PotTrailContainer:Trail:GreyFireball${amount}`
      );
      const otherPos = resourceManager.get(
        `slotContainer:jackpotBonusFeatureContainer:${awardType}PotTrailContainer:Trail`
      );
      const mainPos = resourceManager.get(
        `slotContainer:jackpotBonusFeatureContainer:${awardType}PotTrailContainer`
      );

      const pos = {
        x: thisPos.x + otherPos.x + mainPos.x,
        y: thisPos.y + otherPos.y + mainPos.y,
      };

      return pos;
    };

    doAfterMovingBall(award, potChosen, cb) {
      for (let index = 0; index < award.newTrailPosition; index++) {
        const trail = potChosen.trails[index];
        trail.activeFireball.visible = true;
      }

      const self = this;

      soundManager.play(`jpIncrease${award.newTrailPosition}`);

      this.potMoveTweenProgress = 0;
      gsap
        .timeline()
        .to(this, {
          potMoveTweenProgress: 100,
          duration: 0.2,
          ease: "power1.inOut",
          onUpdate: () => {
            const initialY = potChosen.mainContainerStartPos.position.getY();
            const newYDiff = (this.potMoveTweenProgress * -40) / 100;
            potChosen.mainContainer.y = initialY + newYDiff;
          },
          onComplete: () => {
            this.potMoveTweenProgress = 0;
          },
        })
        .to(this, {
          potMoveTweenProgress: 100,
          duration: 0.1,
          ease: "power1.out",
          onUpdate: () => {
            const initialY = potChosen.mainContainerStartPos.position.getY();
            const newYDiff = (this.potMoveTweenProgress * 5) / 100;
            potChosen.mainContainer.y = initialY - 40 + newYDiff;
          },
          onComplete: () => {
            this.potMoveTweenProgress = 0;
          },
        })
        .to(this, {
          potMoveTweenProgress: 100,
          duration: 0.1,
          ease: "power1.in",
          onUpdate: () => {
            const initialY =
              potChosen.mainContainerStartPos.position.getY() - 35;
            const newYDiff = (this.potMoveTweenProgress * 35) / 100;
            potChosen.mainContainer.y = initialY + newYDiff;
          },
          onComplete: () => {
            if (award.jackpotAwarded) {
              gameData.musicManager.playJackpotCelebrationMusic();
              self.jackpotAwarded = true;
              gsap.fromTo(
                potChosen.mainContainer,
                {
                  pixi: { scale: 1 },
                },
                {
                  pixi: { scale: 1.2 },
                  yoyo: true,
                  repeat: 5,
                  duration: 0.2,
                  onComplete: () => {
                    timerManager.addTimeout(
                      250,
                      self.awardJackpot.bind(self, award, potChosen, cb)
                    );
                  },
                }
              );
            } else {
              timerManager.addTimeout(100, cb.bind(self));
            }
          },
        });
    }

    processAward_Cash(award, cb) {
      soundManager.play(`reelInstant`);
      this._reels[this.symbolAwardIndex - 1].bounceOverlaysSlow(1);

      const winTotal = this._winnings + award.winAmount;
      this.counterCountUp(winTotal, cb, 350);
    }

    awardJackpot(award, pot, cb) {
      const self = this;
      pot.awardValue.setText(gdk.formatCurrency(award.winAmount));

      pot.awardContainer.visible = true;
      const oldPos = pot.awardContainer.position.y;
      self.dimReels.alpha = 0;
      self.dimReels.visible = true;

      gsap.to(self.dimReels, {
        duration: 0.2,
        ease: "power1.inOut",
        alpha: 1,
      });

      pot.awardContainer.scale = { x: 0, y: 0 };

      gsap.to(pot.awardContainer.scale, {
        duration: 0.5,
        ease: "bounce",
        x: 1,
        y: 1,
      });

      gsap
        .timeline()
        .to(pot.awardContainer.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos + 4,
        })
        .to(pot.awardContainer.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos - 8,
          onComplete: () => {},
        })
        .to(pot.awardContainer.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos,
        })
        .to(pot.awardContainer.position, {
          duration: 0.8,
          ease: "linear",
          y: oldPos + 4,
        })
        .to(pot.awardContainer.scale, {
          duration: 0.2,
          ease: "linear",
          y: 1.1,
          x: 1.1,
          onStart: () => {
            gsap.to(pot.awardContainer.position, {
              duration: 0.6,
              ease: "linear",
              y: oldPos - 100,
            });
          },
          onComplete: () => {
            gsap.to(pot.awardContainer.position, {
              duration: 0.6,
              ease: "linear",
              y: oldPos + 1000,
            });
            gsap.to(pot.awardContainer.scale, {
              duration: 0.4,
              ease: "linear",
              y: 0,
              x: 0,
            });
          },
        });

      pot.awardEmitter.visible = true;
      pot.awardEmitter.particleEmitter.emit = true;

      pot.awardGodrays.visible = true;

      pot.awardGodrays.rotation = 0;

      gsap.to(pot.awardGodrays, {
        duration: 3.5,
        rotation: Math.PI * 2,
        ease: "linear",
        onComplete: () => {
          pot.awardGodrays.visible = false;
        },
      });

      timerManager.addTimeout(4500, function () {
        if (self.symbolAwardIndex - 1 < 2) {
          gsap.to(self.dimReels, {
            duration: 0.2,
            ease: "power1.inOut",
            alpha: 0,
            onComplete: () => {
              self.dimReels.visible = false;
            },
          });
        }
        pot.awardGodrays.visible = false;
        pot.awardEmitter.visible = false;
        pot.awardEmitter.particleEmitter.emit = false;
        pot.awardContainer.scale = { x: 1, y: 1 };
        pot.awardContainer.position.y = oldPos;
        pot.awardContainer.visible = false;
        const totalWin = self._winnings + award.winAmount;
        pot.value.setText(gdk.formatCurrency(award.newJackpotAmount));
        pot.reelValue.setText(gdk.formatCurrency(award.newJackpotAmount));
        self.counterCountUp(totalWin, cb, 350);
        for (let index = 0; index < pot.trails.length; index++) {
          const trail = pot.trails[index];
          trail.activeFireball.visible = false;
        }
        //cb();
      });
    }

    finishProcessingSymbolAwards() {
      this.afterEventsProcessedCallback();
    }

    setupArrowPulse() {
      const self = this;
      const duration = 0.5;

      const lArrowX = 78;
      const lArrowXEnd = 58;
      const rArrowX = 788;
      const rArrowXEnd = 808;

      this.lArrowPulse = gsap
        .timeline({ repeat: -1 })
        .to(this.arrowL, {
          duration: duration,
          ease: "power1.inOut",
          x: lArrowXEnd,
        })
        .to(this.arrowL, {
          duration: duration,
          ease: "power1.inOut",
          x: lArrowX,
          onComplete: () => {
            if (!self.repeatPulseArrow) {
              self.lArrowPulse.pause();
            }
          },
        });

      this.lArrowPulse.pause();

      this.rArrowPulse = gsap
        .timeline({ repeat: -1 })
        .to(this.arrowR, {
          duration: duration,
          ease: "power1.inOut",
          x: rArrowXEnd,
        })
        .to(this.arrowR, {
          duration: duration,
          ease: "power1.inOut",
          x: rArrowX,
          onComplete: () => {
            if (!self.repeatPulseArrow) {
              self.rArrowPulse.pause();
            }
          },
        });

      this.rArrowPulse.pause();
    }

    setUpPotTrails() {
      const pots = ["Mega", "Ultra", "Major", "Minor", "Mini"];
      this.pots = [];

      for (let index = 0; index < pots.length; index++) {
        const pot = pots[index];
        const potObject = {
          name: pot,
        };
        potObject.mainContainer = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:" +
            pot +
            "PotTrailContainer"
        );
        potObject.mainContainerStartPos = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:" +
            pot +
            "PotTrailContainerStartPos"
        );
        potObject.fireBall = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:PotFireballSprites:" +
            pot +
            "PotSprite"
        );

        potObject.emitter = particleManager.createEmitter(
          pot + "_emitter",
          "slotContainer:jackpotBonusFeatureContainer:PotFireballSprites:ParticlesContainer",
          0,
          0,
          false
        );
        potObject.emitter.particleEmitter.emit = false;
        potObject.emitter.visible = false;

        potObject.value = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:" +
            pot +
            "PotTrailContainer:value"
        );
        potObject.awardContainer = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:JackpotAwardContainer:" +
            pot +
            "PotTrailContainer"
        );
        potObject.awardGodrays = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:JackpotAwardContainer:Godrays"
        );
        potObject.awardEmitter = particleManager.createEmitter(
          "BW_" + pot + "_emitter",
          "slotContainer:jackpotBonusFeatureContainer:JackpotAwardContainer:" +
            pot +
            "PotTrailContainer:PotParticle",
          0,
          0,
          false
        );
        potObject.awardEmitter.particleEmitter.emit = false;
        potObject.awardEmitter.visible = false;
        potObject.awardValue = resourceManager.get(
          "slotContainer:jackpotBonusFeatureContainer:JackpotAwardContainer:" +
            pot +
            "PotTrailContainer:value"
        );
        potObject.reelValue = resourceManager.get(
          "potContainer:pot" + pot + ":value"
        );
        potObject.trails = [];

        for (let i = 0; i < potObject.mainContainer.Props.trailAmount; i++) {
          const trailActiveFireball = resourceManager.get(
            "slotContainer:jackpotBonusFeatureContainer:" +
              pot +
              "PotTrailContainer:Trail:ActiveFireBall" +
              i
          );
          const trailInActiveFireball = resourceManager.get(
            "slotContainer:jackpotBonusFeatureContainer:" +
              pot +
              "PotTrailContainer:Trail:GreyFireball" +
              i
          );
          if (
            trailActiveFireball !== undefined &&
            trailInActiveFireball !== undefined
          ) {
            potObject.trails.push({
              activeFireball: trailActiveFireball,
              inActiveFireball: trailInActiveFireball,
            });
          }
          this.pots.push(potObject);
        }
      }
    }

    onfireballLinkDataEventCallback() {
      this._dataEvent.leave();
    }

    onjackpotBonusDataEventDead(task) {
      messageBus.post("spinner:stormLinkEnd");

      if (this.jackpotAwarded && !this.processingFinalSpin) {
        this.jackpotAwarded = false;
        this.showKeepGoingPopup();
      } else {
        this.getNextSpinOutcome();
      }
    }

    showKeepGoingPopup() {
      const self = this;
      soundManager.play("keepGoing");
      this.keepGoing.visible = true;
      this.dimReels.alpha = 0;
      this.dimReels.visible = true;
      self.rays.visible = true;
      self.rays.alpha = 0;

      this.keepGoing.position.y = -500;

      const rotationTween = gsap.to(self.rays, {
        duration: 6,
        rotation: Math.PI * 2,
        ease: "linear",
        repeat: -1,
      });

      gsap
        .timeline()
        .to(self.dimReels, {
          duration: 0.2,
          ease: "power1.inOut",
          alpha: 1,
        })
        .to(self.keepGoing.position, {
          duration: 0.5,
          ease: "power1.inOut",
          y: 40,
          onComplete: () => {
            gsap.to(self.rays, {
              duration: 0.2,
              ease: "power1.inOut",
              alpha: 1,
            });
          },
        })
        .to(self.keepGoing.scale, {
          duration: 0.5,
          ease: "power1.inOut",
          x: 1.4,
          y: 1.4,
          onComplete: () => {},
        })
        .to(self.keepGoing.scale, {
          duration: 0.2,
          ease: "power1.inOut",
          x: 1,
          y: 1,
          onComplete: () => {},
        })
        .to(self.keepGoing.scale, {
          duration: 0.5,
          ease: "power1.inOut",
          x: 1.4,
          y: 1.4,
          onComplete: () => {
            gsap.to(self.rays, {
              duration: 0.2,
              ease: "power1.inOut",
              alpha: 0,
            });
          },
        })
        .to(self.keepGoing.scale, {
          duration: 0.2,
          ease: "power1.inOut",
          x: 1,
          y: 1,
          onComplete: () => {},
        })
        .to(self.keepGoing.position, {
          duration: 0.1,
          ease: "power1.inOut",
          y: 50,
          onComplete: () => {
            gsap.to(self.dimReels, {
              duration: 0.3,
              ease: "power1.inOut",
              alpha: 0,
            });
          },
        })
        .to(self.keepGoing.position, {
          duration: 0.4,
          ease: "power1.inOut",
          y: 500,
          onComplete: () => {
            self.getNextSpinOutcome();
            rotationTween.kill();
            self.rays.rotation = 0;
            self.rays.visible = false;
            self.keepGoing.visible = false;
          },
        });
    }

    doFullFireballCelebration(callback) {
      soundManager.play("freeSpinsBonusWon");

      this._megaPotWon = true;

      let symbolsToAnimate = [];
      this._prizes.forEach(function (prize) {
        const reel = prize.reel * gameData.numRows + prize.row;
        symbolsToAnimate.push({
          cell: { reel, row: 0 },
          symbolId: prize.symbolId,
        });
      });

      const self = this;
      timerManager.addTimer(
        1000,
        function () {},
        function () {
          const x = layoutController.getCurrentPosition(
            self._megaValue.Props.FQN
          ).x;
          const y = layoutController.getCurrentPosition(
            self._megaValue.Props.FQN
          ).y;
          self._megaValue.position.set(x, y);
          self._megaValue.visible = false;
          self.countUpPrize(self._megaPotValue, function () {}, 1000);
        }
      );
      this._fireballLandAnimator.animateSymbols(
        symbolsToAnimate,
        this._slotMachine,
        true,
        true,
        function () {
          self._fireballLandAnimator.animateSymbols(
            symbolsToAnimate,
            self._slotMachine,
            true,
            true,
            function () {
              self._fireballLandAnimator.animateSymbols(
                symbolsToAnimate,
                self._slotMachine,
                true,
                true,
                function () {
                  callback();
                }
              );
            }
          );
        }
      );
    }

    processPrizes(callback) {
      this._multipliers = [];
      this._currentPrizeIndex = 0;

      gameData.musicManager.lowerFreeSpinsVolume();

      gameController.stormLinkPayout = true;

      if (this._fireballsCollected === gameData.numReels * gameData.numRows) {
        const self = this;
        this.doFullFireballCelebration(function () {
          self.sortPrizes();
          self.processNextPrize(callback);
        });
      } else {
        if (this._skipped) {
          this.sortPrizes();
          this.skipped(callback);
        } else {
          this.sortPrizes();
          this.processNextPrize(callback);
        }
      }
    }

    skip() {
      this._skipped = true;
    }

    skipped(callback) {
      let total = this._megaPotWon ? this._megaPotValue : 0;
      let multiplier = 1;

      for (let i = 0; i < this._prizes.length; i++) {
        let prize = this._prizes[i];
        let prizeType = prize.prizeData.type;

        if (
          prizeType === "Cash" ||
          prizeType === "WildCash" ||
          prizeType === "Pot" ||
          prizeType === "WildPot"
        ) {
          total += prize.prizeData.value;
        } else if (
          prizeType === "Multiplier" ||
          prizeType === "WildMultiplier"
        ) {
          multiplier *= prize.prizeData.value;
        }
      }

      this.countUpToNumber(total * multiplier, callback, 1000);

      soundManager.play("coinSplash");
    }

    getCurrentMaxWin() {
      if (gameController.inFirelink) {
        return this._maxWin - gameController.freespinsWinnings;
      } else {
        return this._maxWin;
      }
    }

    /**
     * Returns a random integer between min (inclusive) and max (inclusive).
     * The value is no lower than min (or the next integer greater than min
     * if min isn't an integer) and no greater than max (or the next integer
     * lower than max if max isn't an integer).
     */
    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    animateCoins(startPos, endPos, duration) {
      const group = this._coinGroups[this._currentCoinGroup];

      for (let i = 0; i < group.length; i++) {
        const coin = group[i];
        const xx = this.getRandomInt(-20, 20);
        const yy = this.getRandomInt(-25, -15);
        const rotation = this.getRandomInt(0, 10);

        coin.visible = true;
        coin.scale.set(0.5, 0.5);
        coin.rotation = rotation;
        coin.position.set(startPos.x + xx, startPos.y + yy);
        coin.alpha = 0;

        gsap
          .timeline()
          .to(coin, {
            duration: 0.2,
            alpha: 1,
          })
          .to(
            coin,
            {
              duration,
              delay: i / 20,
              pixi: { scaleX: 0, scaleY: 0 },
              ease: "power3.in",
            },
            "<"
          )
          .to(
            coin,
            {
              duration,
              delay: i / 20,
              x: endPos.x,
              y: endPos.y,
              ease: "power1.out",
              onComplete: () => {
                coin.visible = false;
              },
            },
            "<"
          );
      }

      if (this._currentCoinGroup === 0) {
        this._currentCoinGroup = 1;
      } else {
        this._currentCoinGroup = 0;
      }
    }

    collectPrize(objectToMove, reel, row, callback) {
      const symbolInfo = resourceManager.getConfiguration().symbols;
      const symbolId = this._currentBaseGameSymbols[reel][row];

      //I have no idea why this is happening and too busy to find out
      if (reel === 5 && row === 1) {
        objectToMove.x = 1105;
        objectToMove.y = 396;
      }

      const posX = objectToMove.x;
      const posY = objectToMove.y;

      const endPos = layoutController.getCurrentPosition(
        this._winningsPanel.Props.FQN
      );

      const speed = 3;
      const distanceX = Math.max(1, posX - endPos.x);
      const distanceY = Math.max(1, posY - endPos.y);
      const distance = distanceX + distanceY;
      const time = (1 + distance / 1000) / speed;

      if (symbolId >= 18) {
        let soundIndex = Math.floor(
          Math.random() * gameController.blazingBountyWooshSound.length
        );
        soundManager.play(gameController.blazingBountyWooshSound[soundIndex]);
      }

      objectToMove.visible = true;

      this._particleEmitter.particleEmitter.cleanup();
      this._particleEmitter.x = posX;
      this._particleEmitter.y = posY;
      this._particleEmitter.particleEmitter.emit = true;
      soundManager.play("coinSplash");
      this.animateCoins({ x: posX, y: posY }, endPos, time);

      gsap
        .timeline()
        .to(objectToMove, {
          duration: 0.2,
          pixi: { scaleX: 1.3, scaleY: 1.3 },
          ease: "power1.out",
        })
        .to(objectToMove, {
          duration: 0.2,
          pixi: { scaleX: 1, scaleY: 1 },
          ease: "power1.in",
          onComplete: () => {
            objectToMove.visible = false;
            objectToMove.alpha = 1;
            callback();
          },
        });
    }

    toggleOverlay(show, reel, row) {
      this._stormLinkReels[reel][row].alpha = show ? 1 : 0;
      this._freeSpinsReels[reel][row].alpha = show ? 1 : 0;
    }

    setWinnings(newWinnings) {
      this._winnings = newWinnings;
    }

    countUpToNumber(total, callback, duration = 150) {
      const self = this;
      const start = this._winnings;
      const end = Math.min(total, this.getCurrentMaxWin());
      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._winningsText.setText(gdk.formatCurrency(val));

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._winningsText.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self._winningsText.setText(gdk.formatCurrency(self._winnings));
          self._winningsText.scale.set(1, 1);
          if (end >= self.getCurrentMaxWin()) {
            self._maxWinBreached = true;
          }
          callback();
        }
      );
    }

    counterCountUp(total, callback, duration = 150) {
      const self = this;
      const start = parseFloat(self._winnings);
      const end = Math.min(total, this.getCurrentMaxWin());

      this.dimReels.alpha = 0;

      soundManager.play("countUpLoop");

      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self.winningsCounterText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              val / 100
            )
          );

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self.winningsCounterText.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self.winningsCounterText.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              self._winnings / 100
            )
          );
          self.winningsCounterText.scale.set(1, 1);
          if (end >= self.getCurrentMaxWin()) {
            self._maxWinBreached = true;
          }
          timerManager.addTimeout(250, () => {
            soundManager.stop("countUpLoop");
            soundManager.play("countUpLoopEnd");
            callback();
          });
        }
      );
    }

    countUpPrize(newValue, callback, duration = 350) {
      const self = this;
      const start = this._winnings;
      const end = Math.min(start + newValue, this.getCurrentMaxWin());
      timerManager.addTimer(
        duration,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._winningsText.setText(gdk.formatCurrency(val));

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._winningsText.scale.set(newScale, newScale);
        },
        function () {
          self._winnings = end;
          self._winningsText.setText(gdk.formatCurrency(self._winnings));
          self._winningsText.scale.set(1, 1);
          if (end >= self.getCurrentMaxWin()) {
            self._maxWinBreached = true;
          }
          callback();
        }
      );
    }

    showWinningsPanel(show, callback) {
      if (
        (show && !this._winningsPanel.visible) ||
        (!show && this._winningsPanel.visible)
      ) {
        if (show) {
          this._winningsPanel.visible = true;
          this._winningsPanel.alpha = 0;
        }
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            if (show) {
              self._winningsPanel.alpha = progress;
            } else {
              self._winningsPanel.alpha = 1 - progress;
            }
          },
          function () {
            self._winningsPanel.alpha = 1;
            if (!show) {
              self._winningsPanel.visible = false;
            }
            callback();
          }
        );
      } else {
        callback();
      }
    }

    onjackpotBonusEndEvent(task) {
      task.join();
      soundManager.stop("reelSpin");
      this._endEvent = task;

      this._endTaskWinnings = task.data.winAmount;

      gameController.jackpotBonusWinnings = task.data.winAmount;
      this.symbolAwardIndex = 0;

      this._megaPotWon = false;

      this._reelsTimer = undefined;

      messageBus.post("spinner:stormLinkEnd");

      this.onjackpotBonusEndCallback();
    }

    onjackpotBonusEndCallback() {
      const self = this;
      this.doEndWinSequencePopUp();
    }

    doEndWinSequencePopUp() {
      const self = this;

      this.endingWinValueContainer.visible = false;
      this.endingWinSequence.visible = true;
      this.endingWinSequence.alpha = 0;
      this.endingWinValueContainer.scale = {
        x: 0,
        y: 0,
      };
      this.endingWinValue.setText(
        gdk.formatCurrency(self._winnings).replace("X", "")
      );
      this._winnings = 0;
      this.dimReels.visible = true;

      gsap.to(this.dimReels, {
        duration: 0.3,
        ease: "power1.inOut",
        alpha: 0.8,
      });
      soundManager.play("jpEnd");
      gsap.to(this.endingWinSequence, {
        duration: 0.4,
        ease: "power1.inOut",
        alpha: 1,
      });

      gsap
        .timeline()
        .to(this.endingWinValueContainer.scale, {
          duration: 0.5,
          ease: "bounce.out",
          x: 0,
          y: 0,
          onComplete: () => {
            this.endingWinValueContainer.visible = true;
          },
        })
        .to(this.endingWinValueContainer.scale, {
          duration: 0.3,
          ease: "bounce.out",
          x: 1,
          y: 1,
          onComplete: () => {
            gsap
              .timeline()
              .to(this.endingWinValueContainer.scale, {
                duration: 0.5,
                ease: "bounce.out",
                x: 1,
                y: 1,
              })
              .to(this.endingWinValueContainer.scale, {
                duration: 1,
                ease: "linear",
                x: 1,
                y: 1,
              })
              .to(this.endingWinSequence, {
                duration: 0.4,
                ease: "power1.inOut",
                alpha: 0,
                onComplete: () => {
                  this.endingWinSequence.alpha = 1;
                  this.endingWinSequence.visible = false;
                  this.dimReels.visible = false;
                  this.endFeature();
                },
              });
          },
        });
    }

    endFeature() {
      const self = this;
      gameController.cancelAutoplay();

      if (!this._inFS) {
        this._logo.visible = true;
        this._logo.alpha = 0;

        gsap.to(this._logo, {
          duration: 0.3,
          alpha: 1,
        });
      }

      for (let i = 0; i < this._slotMachine._reelVisuals.length; i++) {
        this._slotMachine._reelVisuals[i].suspendUpdates();
      }
      for (let i = 0; i < gameController.slotMachine._reelVisuals.length; i++) {
        gameController.slotMachine._reelVisuals[i].clearSuspendUpdates();
      }

      this.winningsCounter.visible = false;
      this.winningsCounterText.visible = false;

      for (let index = 0; index < this.pots.length; index++) {
        const pot = this.pots[index];
        pot.mainContainer.visible = false;
        for (let tIndex = 0; tIndex < pot.trails.length; tIndex++) {
          const trail = pot.trails[tIndex];
          trail.activeFireball.visible = false;
        }
      }

      gameController.stormLinkPayout = false;
      this._skipped = false;

      gameController.winningsContainer.visible = true;

      gameData.winningsMeter.add(this._endTaskWinnings);
      gameData.musicManager.fadeOutAllMusic();
      gameData.musicManager.setIdleMusic();
      gameData.musicManager.increaseLevel("base");
      timerManager.addDelayedTimer(
        1000,
        500,
        function (progress) {
          self._winningsPanel.alpha = 1 - progress;
        },
        function () {
          self._winningsPanel.alpha = 1;
          self._winningsPanel.visible = false;
          self.reelsBackingContainer.visible = false;
          self.reelsContainer.visible = false;
          gameController.blazingMultiplierContainer.visible = true;
          gameController.baseReelFrame.visible = true;
          gameController.inFirelink = false;
          gameController.wildLandAnimator.visible = true;

          resourceManager.get("slotContainer:reelContainer").visible = true;

          resourceManager.get("slotContainer:jackpotReelsLogo").visible = true;

          resourceManager.get(
            "slotContainer:triggeredByVolcano"
          ).visible = true;

          //this._winlinesTab.visible = true;

          // maybe not if in freespins or if we have a pot bonus
          if (
            gameController.inFreeSpins === false &&
            gameController.isPotBonus === null
          ) {
            self._linkBG.visible = false;
            self._linkBGPortrait.visible = false;
          } else {
            self._volcanoPot.visible = true;
          }

          gameData.reels.forEach(function (reel) {
            reel.lockFireballCashValues(true);
          });
          gameController.isInFeature = true;

          self._slotMachine.clearDimSymbolIds();

          self.visible = false;
          self._endEvent.leave();
          self._endEvent = undefined;
          self._active = false;
        }
      );
    }

    onFreespinsStart() {
      this._inFS = true;
    }

    onFreespinsEndEvent() {
      this._inFS = false;
    }

    skip() {
      this._skipped = true;
    }
  }

  var jackpotBonusFeatureCreator = function (json) {
    return new jackpotBonusFeature();
  };

  var jackpotBonusFeatureInitialiser = function (json, jackpotBonusFeature) {};

  var jackpotBonusFeatureFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "jackpotBonusFeature",
    jackpotBonusFeatureCreator,
    jackpotBonusFeatureInitialiser,
    jackpotBonusFeatureFilesRequired
  );
})();
